"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractArchive = void 0;
const generic_archive_extractor_1 = require("../generic-archive-extractor");
exports.extractArchive = (0, generic_archive_extractor_1.createExtractArchive)(generic_archive_extractor_1.kanikoArchiveConfig);
//# sourceMappingURL=layer.js.map